import styled from "@emotion/styled";
import packageJson from "../../package.json";

function VersionLabel() {
  return <Label>v{packageJson.version}</Label>;
}

export default VersionLabel;

const Label = styled.div`
  position: fixed;
  bottom: 0.5em;
  right: 0.5em;
  color: white;
  font-size: 10px;
  font-weight: 500;
  z-index: 10000;
  pointer-events: none;
  user-select: none;
`;
